// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"252":"37405384","442":"ba1ce2dd"}[chunkId] + ".chunk.js";
};